import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomeScreen from "@/pages/HomeScreen";
import SetupScreen from "@/pages/SetupScreen";
import OnlineScreen from "@/pages/OnlineScreen";
import JoinScreen from "@/pages/JoinScreen";
import LobbyScreen from "@/pages/LobbyScreen";
import GameScreen from "@/pages/GameScreen";
import FeedbackInboxScreen from "@/pages/FeedbackInboxScreen";
import DesignerTag from "@/components/game/DesignerTag";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/local" element={<SetupScreen />} />
          <Route path="/online" element={<OnlineScreen />} />
          <Route path="/join/:code" element={<JoinScreen />} />
          <Route path="/lobby/:code" element={<LobbyScreen />} />
          <Route path="/game/:gameId" element={<GameScreen />} />
          <Route path="/feedback-inbox" element={<FeedbackInboxScreen />} />
        </Routes>
        <DesignerTag />
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            border: "1px solid var(--line)",
            borderRadius: "var(--radius)",
            background: "var(--card)",
            color: "var(--ink)",
            fontFamily: "var(--font-ui)",
            fontSize: 13,
            boxShadow: "var(--shadow-card)",
          },
          classNames: {
            error: "toast-error",
          },
        }}
      />
    </div>
  );
}

export default App;
